import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyApCn4qqsTZA9qgCygfzduchgOY6GKjQ8U",
  authDomain: "yourpack-us.firebaseapp.com",
  projectId: "yourpack-us",
  storageBucket: "yourpack-us.firebasestorage.app",
  messagingSenderId: "831441082632",
  appId: "1:831441082632:web:9e19fae8f4dcb1f49a34bd"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: 'select_account' });
